import React from "react";
import { string, any, bool, func, oneOf } from "prop-types";
import { Link } from "@quintype/components";

import "./button.m.css";

const Button = ({ href, children, socialButton = false, variant = "default", eventsPage = false, ...props }) => {
  const getStyleName = () => {
    if (eventsPage) {
      let baseStyle = "events-btn";
      if (variant === "primary") baseStyle += " events-primary";
      if (variant === "secondary") baseStyle += " events-secondary";
      if (variant === "outlined") baseStyle += " events-outlined";
      return baseStyle;
    }
    if (variant === "memberCta") {
      return "member-cta-btn";
    }
    if (variant === "dark") {
      return "dark-btn";
    }
    if (variant === "disabled") {
      return "disabled-btn";
    }
    return "btn";
  };

  if (socialButton) {
    return (
      <a href={href} styleName={getStyleName()}>
        {children}
      </a>
    );
  }
  return href ? (
    <Link href={href} styleName={getStyleName()} aria-label="button">
      {children}
    </Link>
  ) : (
    <button {...props} styleName={getStyleName()} aria-label="button">
      {children}
    </button>
  );
};

Button.propTypes = {
  href: string,
  className: string,
  children: any,
  color: string,
  flat: bool,
  socialButton: bool,
  variant: oneOf(["default", "primary", "secondary", "outlined", "memberCta", "dark", "disabled"]),
  eventsPage: bool,
  onClick: func
};

export default Button;
